import React, {Component, Suspense} from 'react';

class SectionErrorBoundary extends Component {
  state = {failed: false};
  static getDerivedStateFromError() { return {failed: true}; }
  render() {
    if (this.state.failed) {
      return <div className="section-load-state" role="alert">
        <p>{this.props.label}暫時無法載入，請確認連線後重試。</p>
        <button onClick={() => window.location.reload()}>重新載入</button>
      </div>;
    }
    return this.props.children;
  }
}

export default function DeferredSection({label, children}) {
  return <SectionErrorBoundary label={label}>
    <Suspense fallback={<div className="section-load-state" role="status">正在載入{label}…</div>}>
      {children}
    </Suspense>
  </SectionErrorBoundary>;
}
